import { useShownFromStorage } from './presentation.store';

/**
 * 036 (issue 208, FR-035, research R-022) — "answers whether the screen is showing live data. Every
 * control FR-035 removes is rendered under it." One definition, parameterised by the URLs the
 * calling screen depends on — home passes its own five (`home.store.ts`'s `homeViewUrls()`); a
 * screen with nothing stored (every screen but home, this slice) passes an empty list and is always
 * writable, which costs nothing and needs no special case here.
 *
 * `false` exactly when at least one of those URLs is currently drawn from storage — the SAME summary
 * that decides the stored-list line (`core/stored-views/presentation.store.ts`'s
 * `useShownFromStorage`), so a screen can never disagree with itself about whether it is live.
 */
export function useWritable(urls: readonly string[]): boolean {
  return !useShownFromStorage(urls).any;
}
